require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-yb-display-covid-19.json") })
        }
      }, "path---news-yb-display-covid-19");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-yb-display-covid-19!./.cache/json/news-yb-display-covid-19.json
// module id = 876
// module chunks = 231608221292675